import Dashboard from "../views/Dashboard";
import Projects from "../views/projects/Projects";
import Crews from "../views/crews/Crews";
import Items from "../views/items/Items";
import Users from "../views/Users";
import Settings from "../views/settings/Settings";
import Contacts from "../views/Contacts";
import ContactShow from "../views/contacts/ContactShow";
import ProjectShow from "../views/projects/ProjectShow";
import ContractShow from "../views/contracts/ContractShow";
import ContractScopeOfWork from "../views/contracts/ContractScopeOfWork";
import ContractContacts from "../views/contracts/ContractContacts";
import ContractPlans from "../views/contracts/ContractPlans";
import ContractProcurements from "../views/contracts/ContractProcurements";
import ContractWorkOrders from "../views/contracts/ContractWorkOrders";
import ContractJobTracking from "../views/contracts/ContractJobTracking";
import ContractNotes from "../views/contracts/ContractNotes";
import Login from "../views/public/Login";
import ForgotPassword from "../views/public/ForgotPassword";
import ResetPassword from "../views/public/ResetPassword";
import ContractProcedures from "../views/contracts/ContractProcedures";
import SearchResults from "../views/SearchResults";
import { UserTypes } from "../constants/user-enums";

export default [
  {
    path: "/",
    name: "dashboard",
    component: Dashboard,
    meta: {
      tabName: "Dashboard",
      allowedUserTypes: Object.values(UserTypes)
    }
  },
  {
    path: "/projects",
    name: "projects",
    component: Projects,
    meta: {
      tabName: "Projects",
      allowedUserTypes: [
        UserTypes.ADMIN,
        UserTypes.DESIGNER,
        UserTypes.CREW_SUPERVISOR
      ]
    }
  },
  {
    path: "/projects/:id",
    name: "projects-show",
    component: ProjectShow,
    props: true,
    meta: {
      tabName: "Projects",
      allowedUserTypes: [
        UserTypes.ADMIN,
        UserTypes.DESIGNER,
        UserTypes.CREW_SUPERVISOR
      ]
    }
  },
  {
    path: "/crews",
    name: "crews",
    component: Crews,
    meta: {
      tabName: "Crews",
      allowedUserTypes: [UserTypes.ADMIN]
    }
  },
  {
    path: "/items",
    name: "items",
    component: Items,
    meta: {
      tabName: "Items",
      allowedUserTypes: [UserTypes.ADMIN]
    }
  },
  {
    path: "/users",
    name: "users",
    component: Users,
    meta: {
      tabName: "Users",
      allowedUserTypes: [UserTypes.ADMIN]
    }
  },
  {
    path: "/contacts",
    name: "contacts",
    component: Contacts,
    meta: {
      tabName: "Contacts",
      allowedUserTypes: [UserTypes.ADMIN]
    }
  },
  {
    path: "/contacts/:id",
    name: "contact-show",
    component: ContactShow,
    props: true,
    meta: {
      tabName: "Contacts",
      allowedUserTypes: [UserTypes.ADMIN]
    }
  },
  {
    path: "/settings",
    name: "settings",
    component: Settings,
    meta: {
      tabName: "Settings",
      allowedUserTypes: Object.values(UserTypes)
    }
  },
  {
    path: "/contracts/:id",
    component: ContractShow,
    props: true,
    meta: {
      tabName: "Projects",
      allowedUserTypes: [
        UserTypes.ADMIN,
        UserTypes.DESIGNER,
        UserTypes.CREW_SUPERVISOR
      ]
    },
    children: [
      {
        path: "",
        name: "contracts-show",
        component: ContractScopeOfWork,
        meta: {
          tabName: "Projects",
          allowedUserTypes: [UserTypes.ADMIN]
        }
      },
      {
        path: "scope-of-work",
        name: "contract-scope-of-work",
        component: ContractScopeOfWork,
        meta: {
          tabName: "Projects",
          allowedUserTypes: [UserTypes.ADMIN]
        }
      },
      {
        path: "procedures",
        name: "contract-procedures",
        component: ContractProcedures,
        meta: {
          tabName: "Projects",
          allowedUserTypes: [UserTypes.ADMIN]
        }
      },
      {
        path: "partners",
        name: "contract-contacts",
        component: ContractContacts,
        meta: {
          tabName: "Projects",
          allowedUserTypes: [
            UserTypes.ADMIN,
            UserTypes.DESIGNER,
            UserTypes.CREW_SUPERVISOR
          ]
        }
      },
      {
        path: "plans",
        name: "contract-plans",
        component: ContractPlans,
        meta: {
          tabName: "Projects",
          allowedUserTypes: [
            UserTypes.ADMIN,
            UserTypes.DESIGNER,
            UserTypes.CREW_SUPERVISOR
          ]
        }
      },
      {
        path: "procurements",
        name: "contract-procurements",
        component: ContractProcurements,
        meta: {
          tabName: "Projects",
          allowedUserTypes: [
            UserTypes.ADMIN,
            UserTypes.DESIGNER,
            UserTypes.CREW_SUPERVISOR
          ]
        }
      },
      {
        path: "work-orders",
        name: "contract-work-orders",
        component: ContractWorkOrders,
        meta: {
          tabName: "Projects",
          allowedUserTypes: [
            UserTypes.ADMIN,
            UserTypes.DESIGNER,
            UserTypes.CREW_SUPERVISOR
          ]
        }
      },
      {
        path: "job-tracking",
        component: ContractJobTracking,
        name: "contract-job-tracking",
        meta: {
          tabName: "Projects",
          allowedUserTypes: [
            UserTypes.ADMIN,
            UserTypes.DESIGNER,
            UserTypes.CREW_SUPERVISOR
          ]
        }
      },
      {
        path: "notes",
        component: ContractNotes,
        name: "contract-notes",
        meta: {
          tabName: "Projects",
          allowedUserTypes: [
            UserTypes.ADMIN,
            UserTypes.DESIGNER,
            UserTypes.CREW_SUPERVISOR
          ]
        }
      }
    ]
  },
  {
    path: "/search-results/:term",
    name: "search-results",
    component: SearchResults,
    props: true,
    meta: {
      tabName: "Search Results",
      allowedUserTypes: Object.values(UserTypes)
    }
  },
  {
    path: "/login",
    name: "login",
    component: Login,
    meta: {
      publicView: true
    }
  },
  {
    path: "/forgot-password",
    name: "forgot-password",
    component: ForgotPassword,
    meta: {
      publicView: true
    }
  },
  {
    path: "/forgot-password/:hash/:email",
    name: "reset-password",
    component: ResetPassword,
    meta: {
      publicView: true
    }
  }
];
